export default __webpack_public_path__ + "static/HKGrotesk-Regular-a8ec2340bc567b2f17a3cefd4a35f752.woff2";